import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "customNumber",
})
export class CustomNumberPipe implements PipeTransform {
	transform(value: number, ...args: unknown[]): string {
		if (value == null) {
			return "";
		}
		return value.toLocaleString("vi-VN", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	}
}
